import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/fonts/FiraSans-Regular.ttf';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
